import Square from "./Square";
import Timer from "./Timer";
import {useState} from 'react';

function Board({squares, onPlay, currentMove}) {
    const [date, setDate] = useState(new Date());
    const buttons = document.querySelectorAll('button[data-index]');

    function handleMouseDown(e, item, index) {
        e.stopPropagation();

        if (calculateWinner(squares)) {
            return;
        }
        let gameGrid = document.querySelector('.game-grid');
        let {clientWidth, clientHeight} = gameGrid;

        let touchObj = e.type === "touchstart" ? e.touches[0] : e;

        let {clientX: initX, clientY: initY} = touchObj;
        let {clientX: lastX, clientY: lastY} = touchObj;
        let point = e.target;
        let dim = '';
        let shift = 0;
        let emptySquareIndex = squares.findIndex(item => item === null);
        let thisSquareIndex = parseInt(e.target.dataset.index);
        point.parentNode.classList.add('dragged');
        let ids = [];

        function onMouseMove(e) {
            e.stopPropagation();

            let touchObj = e.type === "touchmove" ? e.touches[0] : e;
            let {clientX, clientY} = touchObj;

            let dir = '';

           /* if (!dim)*/ {
                let shiftX = Math.abs(initX - clientX);
                let shiftY = Math.abs(initY - clientY);
                //console.log(shiftX, shiftY)
                if (shiftX >= shiftY) {
                    dim = 'X';
                } else  {
                    dim = 'Y';
                }
            }

            if (!dim) { return; }

            switch (dim) {
                case 'X':
                    shift = clientX - initX;
                    dir = clientX - lastX > 0 ? 'RIGHT' : 'LEFT'
                    break;
                default:
                    shift = clientY - initY;
                    dir = clientY - lastY > 0 ? 'DOWN' : 'UP'
                    break;
            }

            if (!dir || !shift) { return; }

            let offsetX = point.offsetParent.offsetLeft + point.offsetLeft;
            let offsetY = point.offsetParent.offsetTop + point.offsetTop;

            let allowedDir = null;

            if (thisSquareIndex < emptySquareIndex && thisSquareIndex % 4 >= 0 && emptySquareIndex % 4 < 4 && emptySquareIndex < thisSquareIndex + 4) {
                allowedDir = 'RIGHT';
                for (let i = emptySquareIndex - 1; i >= thisSquareIndex; i--) {
                    ids = [...ids, i];
                }
            } else if (thisSquareIndex > emptySquareIndex && thisSquareIndex % 4 < 4 && emptySquareIndex % 4 >= 0 && emptySquareIndex > thisSquareIndex - 4) {
                allowedDir = 'LEFT';
                for (let i = emptySquareIndex + 1; i <= thisSquareIndex; i++) {
                    ids = [...ids, i];
                }
            } else if (thisSquareIndex < emptySquareIndex && thisSquareIndex % 4 === emptySquareIndex % 4){
                allowedDir = 'DOWN';
                for (let i = emptySquareIndex - 1; i >= thisSquareIndex; i--) {
                    if (i % 4 !== thisSquareIndex % 4) { continue; }
                    ids = [...ids, i];
                }
            } else if (thisSquareIndex > emptySquareIndex && thisSquareIndex % 4 === emptySquareIndex % 4){
                allowedDir = 'UP';
                for (let i = emptySquareIndex + 1; i <= thisSquareIndex; i++) {
                    if (i % 4 !== thisSquareIndex % 4) { continue; }
                    ids = [...ids, i];
                }
            }
            //console.log(thisSquareIndex, emptySquareIndex, allowedDir, ids)
            if (dir !== allowedDir) {
                return;
            }

            if (Math.abs(shift) >= e.target.parentNode.offsetWidth + 1) {
                return;
            }

            //console.log(dir, shift)

            if (!ids.length) {
                return;
            }

            let shiftPercent = shift/point.offsetWidth * 100;

            let prop;
            let val;
            switch (dir) {
                case "LEFT":
                    prop= 'left';
                    val = `${shiftPercent}%`;
                    break;
                case "RIGHT":
                    prop= 'left';
                    val = `${shiftPercent}%`;
                    break;
                case "UP":
                    prop= 'top';
                    val = `${shiftPercent}%`;
                    break;
                default:
                    prop= 'top';
                    val = `${shiftPercent}%`;
                    break;
            }
            ids.forEach(id => {
                let btn = document.querySelector(`button[data-index="${id}"]`);
                btn.style[prop] = val;
                btn.parentNode.classList.add('dragged');
            });

            if (Math.abs(shift) >= 100 / 3 * 2) {
                switch (dir) {
                    case "LEFT":
                        prop= 'left';
                        val = `-${e.target.parentNode.offsetWidth + 1}px`;
                        break;
                    case "RIGHT":
                        prop= 'left';
                        val = `${e.target.parentNode.offsetWidth + 1}%`;
                        break;
                    case "UP":
                         prop= 'top';
                        val = `-${e.target.parentNode.offsetWidth + 1}%`;
                        break;
                    default:
                        prop= 'top';
                        val = `${e.target.parentNode.offsetWidth + 1}%`;
                        break;
                }

                ids.forEach(id => {
                    let btn = document.querySelector(`button[data-index="${id}"]`);
                    btn.style[prop] = val;
                    btn.parentNode.classList.add('dragged');
                });

                const nextSquares = [];
                let isSetNull = false;
                //console.log(ids)
                switch (dir) {
                    case "LEFT":
                        for (let i = 15; i >= 0; i--) {
                            if (i === emptySquareIndex) { continue; }
                            if (!ids.includes(i)) {
                                nextSquares[i] = squares[i];
                            } else {
                                if (!isSetNull) {
                                    nextSquares[i] = null;
                                    isSetNull = true;
                                }
                                nextSquares[i - 1] = squares[i];
                            }
                        }
                        break;
                    case "RIGHT":
                        for (let i = 0; i < 16; i++) {
                            if (i === emptySquareIndex) { continue; }
                            if (!ids.includes(i)) {
                                nextSquares[i] = squares[i];
                            } else {
                                if (!isSetNull) {
                                    nextSquares[i] = null;
                                    isSetNull = true;
                                }
                                nextSquares[i + 1] = squares[i];
                            }
                        }
                        break;
                    case "UP":
                        for (let i = 15; i >= 0; i--) {
                            if (i === emptySquareIndex) { continue; }
                            if (!ids.includes(i)) {
                                nextSquares[i] = squares[i];
                            } else {
                                if (!isSetNull) {
                                    nextSquares[i] = null;
                                    isSetNull = true;
                                }
                                nextSquares[i - 4] = squares[i];
                            }
                        }
                        break;
                    default:
                        for (let i = 0; i < 16; i++) {
                            if (i === emptySquareIndex) { continue; }
                            if (!ids.includes(i)) {
                                nextSquares[i] = squares[i];
                            } else {
                                if (!isSetNull) {
                                    nextSquares[i] = null;
                                    isSetNull = true;
                                }
                                nextSquares[i + 4] = squares[i];
                            }
                        }
                        break;
                }
                //console.log(squares, nextSquares)
                //nextSquares[emptySquareIndex] = nextSquares[thisSquareIndex];
                //nextSquares[thisSquareIndex] = null;

                document.removeEventListener('mousemove', onMouseMove);
                document.removeEventListener('mouseup', dragEnd);
                point.onmouseup = null;

                ids.forEach(id => {
                    let btn = document.querySelector(`button[data-index="${id}"]`);
                    btn.style.top = '0';
                    btn.style.left = '0';
                    btn.parentNode.classList.remove('dragged');
                });


                onPlay(nextSquares, index);
            }

            lastX = touchObj.clientX;
            lastY = touchObj.clientY;
        }

        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('touchmove', onMouseMove);

        let dragEnd = function(e) {
            e.stopPropagation();

            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('touchmove', onMouseMove);
            document.removeEventListener('mouseup', dragEnd);
            document.removeEventListener('touchend', dragEnd);

            ids.forEach(id => {
                let btn = document.querySelector(`button[data-index="${id}"]`);
                btn.onmouseup = null;
                btn.parentNode.classList.remove('dragged');
                if (Math.abs(shift) < 100 / 3 * 2) {
                    btn.style.top = '0';
                    btn.style.left = '0';
                }
            });
        };
        document.addEventListener('mouseup', dragEnd);
        document.addEventListener('touchend', dragEnd);
    }

    function calculateWinner(squares) {
        let result = true;
        if  (squares.find((item, index) => item !== index + 1 && item !== null)){
            result = false;
        }

        return result;
    }

    let hours = date.getHours();
    let minutes = date.getMinutes();
    let seconds = date.getSeconds();

    const isWin = calculateWinner(squares);

    let win = '';
    if (isWin) {
        win = <div>
            <h1>Ура! Вы выиграли!</h1>
            <p className="win-stats">Ход: {currentMove}</p>
            <p className="win-stats">Время: {hours}:{minutes}:{seconds}</p>
        </div>
    }

    return (
        <>
            <div className="status">
                <div className="status-item">Ход: {currentMove}</div>
                <Timer date={date}/>
            </div>
            <div className={`game-grid`}>
                {squares.map((item, itemIndex) =>
                    <Square
                        key={itemIndex}
                        value={item}
                        index={itemIndex}
                        onMouseDown={(e) => handleMouseDown(e, item, itemIndex)}
                        onTouchStart={(e) => handleMouseDown(e, item, itemIndex)}/>
                )}
            </div>
            {win}
        </>
    );
}

export default Board;